/**
 * Impressão de PDF NA MESMA PÁGINA — via iframe oculto + diálogo de impressão,
 * sem abrir aba/janela nova. Mesmo padrão do cupom do PDV (imprimirCupom).
 *
 * Uso: api.get(url, { responseType: 'blob' }).then(r => imprimirPdfBlob(r.data))
 */
export function imprimirPdfBlob(data: Blob | BlobPart) {
  const blob = data instanceof Blob ? data : new Blob([data], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)

  const iframe = document.createElement('iframe')
  iframe.style.position = 'fixed'
  iframe.style.right = '0'
  iframe.style.bottom = '0'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = '0'
  iframe.src = url

  let disparado = false
  const imprimir = () => {
    if (disparado) return
    disparado = true
    try {
      iframe.contentWindow?.focus()
      iframe.contentWindow?.print()
    } catch {
      // Se o navegador bloquear o print no iframe, cai pro comportamento antigo.
      window.open(url, '_blank')
    }
    // Limpa depois que o usuário fecha o diálogo de impressão.
    setTimeout(() => { iframe.remove(); URL.revokeObjectURL(url) }, 60000)
  }

  // Espera o PDF renderizar no iframe antes de chamar print (senão sai em branco).
  iframe.onload = () => setTimeout(imprimir, 250)
  document.body.appendChild(iframe)
}
